import { render, staticRenderFns } from "./CollectionsDashboard.vue?vue&type=template&id=5ae90d42&scoped=true&"
import script from "./CollectionsDashboard.vue?vue&type=script&lang=js&"
export * from "./CollectionsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsDashboard.vue?vue&type=style&index=0&id=5ae90d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae90d42",
  null
  
)

export default component.exports